import { ProductListConfig } from "@b2b/ui-components";

export interface BuyerProfile {
  companyName: string;
  businessType: string;
  location: string;
  memberSince: string;
  totalRFQs: string;
  successfulDeals: string;
}

export interface Specification {
  label: string;
  value: string;
}

export interface Quote {
  id: string;
  supplier: string;
  location: string;
  quoteAmount: string;
  unitPrice: string;
  terms: string;
  paymentTerms: string;
  deliveryTime: string;
  uploads: number;
  rating: number;
}

export interface RFQDetail {
  id: string;
  title: string;
  description: string;
  postedCountry: string;
  postedDate: string;
  expiryDate: string;
  quantity: string;
  timeLeft: string;
  status: "active" | "closed" | "expired";
  buyerProfile: BuyerProfile;
  specifications: Specification[];
  quotes: Quote[];
}

export const rfqDataList: RFQDetail[] = [
  {
    id: "1",
    title: "High-Quality LED Display Panels for Outdoor Advertising",
    description:
      "We are looking for premium outdoor LED display panels with high brightness (minimum 6000 nits) and weather resistance (IP65 rating) for our advertising network across major cities. The panels should support 4K resolution and have a lifespan of at least 100,000 hours.",
    postedCountry: "United States",
    postedDate: "March 15, 2024",
    expiryDate: "March 30, 2024",
    quantity: "500 units",
    timeLeft: "15 days",
    status: "active",
    buyerProfile: {
      companyName: "Digital Media Solutions Inc.",
      businessType: "Advertising Agency",
      location: "New York, NY, USA",
      memberSince: "2020",
      totalRFQs: "45",
      successfulDeals: "38",
    },
    specifications: [
      { label: "Screen Size", value: "55 inches" },
      { label: "Resolution", value: "4K (3840x2160)" },
      { label: "Brightness", value: "6000+ nits" },
      { label: "IP Rating", value: "IP65" },
      { label: "Operating Temperature", value: "-20°C to 60°C" },
      { label: "Warranty", value: "3 years minimum" },
    ],
    quotes: [
      {
        id: "1",
        supplier: "TechDisplay Manufacturing",
        location: "Shenzhen, China",
        quoteAmount: "$125,000",
        unitPrice: "$250",
        terms: "FOB Shenzhen",
        paymentTerms: "30% advance, 70% before shipment",
        deliveryTime: "25-30 days",
        uploads: 3,
        rating: 4.8,
      },
    ],
  },
  {
    id: "2",
    title: "Industrial Grade CNC Machining Services",
    description:
      "Seeking reliable CNC machining services for aluminum parts with tight tolerances. ISO 9001 certification required.",
    postedCountry: "China",
    postedDate: "1 day ago",
    expiryDate: "April 20, 2024",
    quantity: "2000 units",
    timeLeft: "10 days",
    status: "active",
    buyerProfile: {
      companyName: "Precision Manufacturing Co.",
      businessType: "Manufacturing",
      location: "Shanghai, China",
      memberSince: "2018",
      totalRFQs: "60",
      successfulDeals: "52",
    },
    specifications: [
      { label: "Power Output", value: "400W+" },
      { label: "Efficiency", value: "21%" },
      { label: "Warranty", value: "25 years" },
      { label: "Certification", value: "IEC / UL" },
    ],
    quotes: [
      {
        id: "1",
        supplier: "SunPower Corp",
        location: "California, USA",
        quoteAmount: "$500,000",
        unitPrice: "$250",
        terms: "CIF Mumbai",
        paymentTerms: "L/C 30 days",
        deliveryTime: "30-35 days",
        uploads: 4,
        rating: 4.7,
      },
      {
        id: "2",
        supplier: "Trina Solar",
        location: "Changzhou, China",
        quoteAmount: "$480,000",
        unitPrice: "$240",
        terms: "FOB Shanghai",
        paymentTerms: "T/T 40% advance",
        deliveryTime: "25-30 days",
        uploads: 2,
        rating: 4.9,
      },
    ],
  },
  {
    id: "3",
    title: "Organic Cotton Fabric Wholesale",
    description:
      "Looking for GOTS certified organic cotton fabric in various colors for our sustainable fashion line.",
    postedCountry: "Mumbai, India",
    postedDate: "May 2, 2024",
    expiryDate: "May 25, 2024",
    quantity: "50 machines",
    timeLeft: "20 days",
    status: "active",
    buyerProfile: {
      companyName: "EcoFashion Brands",
      businessType: "Manufacturing",
      location: "Berlin, Germany",
      memberSince: "2015",
      totalRFQs: "80",
      successfulDeals: "70",
    },
    specifications: [
      { label: "Type", value: "CNC Milling" },
      { label: "Precision", value: "±0.01mm" },
      { label: "Automation", value: "Yes" },
      { label: "Warranty", value: "5 years" },
    ],
    quotes: [
      {
        id: "1",
        supplier: "Haas Automation",
        location: "California, USA",
        quoteAmount: "$2,500,000",
        unitPrice: "$50,000",
        terms: "FOB Los Angeles",
        paymentTerms: "T/T 30% advance",
        deliveryTime: "60 days",
        uploads: 5,
        rating: 4.8,
      },
    ],
  },
];

// ======================
// Table Config
// ======================
export const rfqTableConfig: ProductListConfig = {
  columns: [
    { key: "supplier", label: "Supplier", align: "left" },
    { key: "quoteAmount", label: "Quote Amount", align: "center" },
    { key: "unitPrice", label: "Unit Price", align: "center" },
    { key: "terms", label: "Terms", align: "left" },
    { key: "deliveryTime", label: "Delivery", align: "center" },
    { key: "uploads", label: "Files", align: "center" },
    { key: "actions", label: "Actions", align: "center" },
  ],
  styles: {
    headerBg: "bg-gray-100",
    headerText: "text-gray-700",
    rowHover: "hover:bg-gray-50",
    statusStyles: {},
  },
};
